import {debounce} from 'lodash';
import qs from 'qs';
import type {Pageable, PaginationSettings} from '@deviceinsight/ng-ui-api-client';
import type {Rule} from '../../modules/ruleengine/types';
import {UiConfigurationApi} from '@deviceinsight/ng-ui-scale-lib/api';
export const HEADER_TITLE = {
	id: 'ruleengine.list.title',
	defaultValue: 'Rules'
};
export type SearchSettings = {
	paginationSettings: PaginationSettings;
	nameFilter: string | null | undefined;
};
export const getQueryParamsFromSearchSettings = ({
	nameFilter,
	paginationSettings: {
		page,
		sort: {property, direction}
	}
}: SearchSettings): string => {
	const params = {
		name: nameFilter,
		page: Math.max(page + 1, 1),
		sort: `${property},${direction}`
	};
	return `?${qs.stringify(params)}`;
};
export const getSearchSettingsFromQueryParams = (queryParams?: string): SearchSettings => {
	const settings: SearchSettings = {
		nameFilter: undefined,
		paginationSettings: {
			sort: {
				property: 'name',
				direction: 'ASC'
			},
			size: 10,
			page: 0
		}
	};

	if (!queryParams) {
		return settings as SearchSettings;
	}

	const params = qs.parse(queryParams.replace('?', ''));
	const pageParam = Math.max(parseInt(params.page as string, 10), 1) || 1;
	settings.paginationSettings.page = pageParam - 1;
	settings.nameFilter = (params.name as string) ?? undefined;
	const sortParams = params.sort ? (params.sort as string).split(',') : [];

	if (sortParams.length && sortParams.length == 2 && sortParams[0]) {
		settings.paginationSettings.sort = {
			property: sortParams[0],
			direction: sortParams[1] === 'DESC' ? 'DESC' : 'ASC'
		};
	}

	return settings;
};
export const initSearchSettings = (queryParams?: string): SearchSettings => {
	const {nameFilter, paginationSettings} = getSearchSettingsFromQueryParams(queryParams);
	const ruleEngineConfig = UiConfigurationApi.getAppConfiguration('ruleengine', undefined);

	if (ruleEngineConfig && ruleEngineConfig.configuration && ruleEngineConfig.configuration.pageSize) {
		paginationSettings.size = ruleEngineConfig.configuration.pageSize;
	}

	return {
		nameFilter,
		paginationSettings
	};
};
export const buildEmptyContent = (): Pageable<Rule> => {
	return {
		content: [],
		totalElements: 0,
		totalPages: 0,
		number: 0,
		size: 0,
		sort: [
			{
				property: 'name',
				direction: 'ASC'
			}
		],
		first: true,
		last: false,
		totalElementsAccurate: true
	};
};
const SEARCH_DELAY = 500;
export const debouncedNameFilter = debounce(
	(name: string, searchSettings: SearchSettings, setSearchSettings: (arg0: SearchSettings) => void) => {
		setSearchSettings({
			...searchSettings,
			paginationSettings: {...searchSettings.paginationSettings, page: 0},
			nameFilter: name
		});
	},
	SEARCH_DELAY
);
